(() => {
  const WRAPPER_ID = 'cart-bar';
  const BAR_SELECTOR = '.cart-bar';
  const CSS_VAR = '--ygb-cart-bar-height';

  let resizeObserver;

  const getBar = () => {
    const wrapper = document.getElementById(WRAPPER_ID);
    return wrapper ? wrapper.querySelector(BAR_SELECTOR) : null;
  };

  // 実際のバーの高さを CSS 変数へ反映する。
  // 文言の折り返しでバーの高さが変わるため、固定値ではヘッダーと重なる。
  const measure = () => {
    const bar = getBar();
    if (!bar) {
      document.body.style.removeProperty(CSS_VAR);
      return;
    }

    const section = bar.closest('.section-cart-bar') || bar;
    const height = section.getBoundingClientRect().height;
    if (height > 0) {
      document.body.style.setProperty(CSS_VAR, `${Math.ceil(height)}px`);
    }
  };

  const observeBar = () => {
    if (resizeObserver) resizeObserver.disconnect();
    if (typeof ResizeObserver === 'undefined') return;

    const bar = getBar();
    if (!bar) return;

    resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(bar);
  };

  const refresh = () => {
    measure();
    observeBar();
  };

  const init = () => {
    refresh();

    const wrapper = document.getElementById(WRAPPER_ID);
    if (wrapper) {
      // カート追加時に Section Rendering API で中身が差し替わる
      new MutationObserver(refresh).observe(wrapper, { childList: true });
    }

    window.addEventListener('resize', measure);
    document.addEventListener('shopify:section:load', refresh);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
